export default __webpack_public_path__ + "static/media/broken-cup.aa057992.svg";